import cn from 'classnames';
import Link from 'next/link';
import { priceFormater } from '@/settings/index';
import { priceFormatSuperscript } from '@/lib/price';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import { ConditionOptionProps } from '../types';

const ConditionOption = ({
  isSelected,
  offer,
  value,
  className,
  variantSlug,
}: ConditionOptionProps) => {
  const { productId } = useProductPageContext();

  const variantValue = value.displayValue ?? value.value;

  return (
    <div className={cn(className, 'relative')}>
      <Link
        href={`/collections/${encodeURIComponent(
          productId,
        )}?skuId=${encodeURIComponent(offer.skuId)}`}
        scroll={false}
        shallow
        id={`e2e-pdp-${variantSlug}-${variantValue}`}
        className={cn(
          'relative flex h-[50px] items-center justify-between rounded border px-2 text-left focus:outline-none',
          {
            'border-slate-gray-200 hover:border-gray-700 hover:text-gray-700':
              !isSelected,
            'border-gray-700': isSelected,
          },
        )}
      >
        <div className="leading-tight">
          <span
            className={cn({
              'font-bold': isSelected,
            })}
          >
            {variantValue}
          </span>
          <span className="mt-1 block" translate="no">
            {priceFormatSuperscript(priceFormater.short(offer.price))}
          </span>
        </div>
      </Link>
    </div>
  );
};

export default ConditionOption;
